import { render, staticRenderFns } from "./RedemptionRpt.vue?vue&type=template&id=20a0fd92&"
import script from "./RedemptionRpt.vue?vue&type=script&lang=js&"
export * from "./RedemptionRpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports